import { ROUTE_KEYS } from '@/navigation/constants';
import { getCompletePathFromRouteKey } from '@/navigation/navigationUtils';

import { ExportEntityBundleModalFormShape } from './ExportEntityBundleModal.types';

export function getPathToExport(
  entityId: string,
  householdId: string,
  deathOrderId: string | null | undefined,
  formData: ExportEntityBundleModalFormShape
) {
  const pathSearchParams: Record<string, string | number | boolean> = {
    ...formData,
  };

  if (deathOrderId) {
    pathSearchParams.deathOrderId = deathOrderId;
  }

  const path = getCompletePathFromRouteKey(
    ROUTE_KEYS.__PRINT_ONLY_SINGLE_ENTITY_WITH_NOTES,
    {
      householdId,
      entityId,
    },
    pathSearchParams
  );

  // the lambda expects this whole path EXCEPT for the leading slash.
  return path.slice(1, path.length);
}

export function getOptionsFromSearchParams(): {
  pageOptions: ExportEntityBundleModalFormShape;
  deathOrderId: string | null;
} {
  const searchParams = new URLSearchParams(window.location.search);
  const deathOrderId = searchParams.get('deathOrderId');
  const includeCoverSlide = searchParams.get('includeCoverSlide');
  const includeDiagramAndNotesSlide = searchParams.get(
    'includeDiagramAndNotesSlide'
  );
  const includeBalanceSheetSlide = searchParams.get('includeBalanceSheetSlide');
  const includeBeneficiariesAndDispositionsSlide = searchParams.get(
    'includeBeneficiariesAndDispositionsSlide'
  );
  const includeNotesOnDiagramSlide = searchParams.get(
    'includeNotesOnDiagramSlide'
  );
  const includeInsurancePolicySlides = searchParams.get(
    'includeInsurancePolicySlides'
  );

  return {
    pageOptions: {
      includeCoverSlide: includeCoverSlide === 'true',
      includeDiagramAndNotesSlide: includeDiagramAndNotesSlide === 'true',
      includeBalanceSheetSlide: includeBalanceSheetSlide === 'true',
      includeBeneficiariesAndDispositionsSlide:
        includeBeneficiariesAndDispositionsSlide === 'true',
      includeNotesOnDiagramSlide: includeNotesOnDiagramSlide === 'true',
      includeInsurancePolicySlides: includeInsurancePolicySlides === 'true',
    },
    deathOrderId,
  };
}
